<template>
  <div>
    <app-cells position="between">
      <h1 class="title">Client groups</h1>
      <app-button
        v-if="is_general_manager || is_sales_supervisor"
        @click.native="onExport"
        theme="export"
        :class="{'btn--export--loading': export_loading }"
      >
        <img src="@/assets/img/export-icon.svg" alt="Export">
        <span>Export in .xlsx</span>
      </app-button>
    </app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view  />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'
import { getClientsGroupsExport } from '@/http'
import { format } from 'date-fns'

export default {
  name: 'ClientGroupsLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'clients-groups', label: 'Upcoming' },
        { name: 'clients-groups-tour', label: 'In tour' },
        { name: 'clients-groups-archive', label: 'Archive' },
      ],
      export_loading: false,
    }
  },
  computed: {
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
    is_sales_supervisor() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_supervisor')
    },
  },
  methods: {
    onExport() {
      this.export_loading = true
      getClientsGroupsExport()
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `Client groups export ${format(new Date(), 'dd.MM.yyyy HH_mm')}.xlsx`)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(url)
          this.export_loading = false
        })
    },
  }
}
</script>
